var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombinedPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10,
    fill: "none",
    viewBox: "0 0 11 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.978 3.296c0 1.504 1.255 2.727 2.797 2.727 1.541 0 2.796-1.223 2.796-2.727 0-1.504-1.255-2.727-2.796-2.727-1.542 0-2.797 1.223-2.797 2.727zm5.577 2.366a.206.206 0 01.205.001c.046.029.087.058.128.087.024.017.047.034.072.05 2.283 1.548 1.46 3.782 1.423 3.88l-.05.12a.201.201 0 01-.184.12h-8.75a.2.2 0 01-.186-.125l-.044-.112C1.164 9.675.23 7.398 2.59 5.801c.025-.016.049-.033.072-.05.042-.03.083-.06.13-.088a.201.201 0 01.2-.002l.085.09a3.726 3.726 0 002.697 1.15 3.727 3.727 0 002.703-1.155l.078-.084z",
    clipRule: "evenodd"
  })));
}
SvgCombinedPerson.displayName = 'CombinedPerson';
export default SvgCombinedPerson;